import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "./MemberProfileModals.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";

type Props = {
  serviceUserName: string;
  visible: boolean;
  setVisibility: Function;
  handleYesRemove: () => void;
};

function RemoveTrustedContactModal({
  serviceUserName,
  visible,
  setVisibility,
  handleYesRemove,
}: Props) {
  const { width } = useWindowSize();

  function handleClose() {
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.removeTrustedContactModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center" gutter={[10, 10]}>
          <Button className={styles.cancelBtn} onClick={handleClose}>
            Cancel
          </Button>
          <Button className={styles.yesRemoveBtn} onClick={handleYesRemove}>
            Yes, Remove
          </Button>
        </Row>
      }
    >
      <Row justify="center" gutter={[0, 20]}>
        <Col className={styles.title}>Remove Trusted Contact</Col>
        <Col span={24} className={styles.description}>
          Are you sure you want to remove <strong>{serviceUserName}</strong> as
          a Trusted Contact?
        </Col>
      </Row>
    </Modal>
  );
}

export default RemoveTrustedContactModal;
